import { noop } from 'lodash';

const alwaysNoop = noop;

export default alwaysNoop;
